import { render, staticRenderFns } from "./TSGFrischwasserPreview.vue?vue&type=template&id=3e6ec442&scoped=true&"
import script from "./TSGFrischwasserPreview.vue?vue&type=script&lang=ts&"
export * from "./TSGFrischwasserPreview.vue?vue&type=script&lang=ts&"
import style0 from "./TSGFrischwasserPreview.vue?vue&type=style&index=0&id=3e6ec442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ec442",
  null
  
)

export default component.exports